module.exports = __webpack_public_path__ + "img/HEART SHADES PURPLE.43e7da5.svg";